// extracted by mini-css-extract-plugin
export default {"SearchBlock":"search-block_SearchBlock__Y67BT"};